import Helpers from '@/helpers.js'

export default {

  async requestUserTimeline({ commit, rootState }) {
    // General home page data
    if (rootState.currentUser.me.id) {
      commit('requestingHomepageData')

      const prefs = rootState.currentUser.me.preferences.timeline

      const criteria = {
        page: 0,
        pageSize: 10,
        showConversations: prefs.conversations,
        showCreated: prefs.created,
        showDocuments: prefs.documents,
        showParticipants: prefs.participants,
        showStateChanges: prefs.stateChanges,
        showTasks: prefs.tasks,
        showUpdates: prefs.updates,
        showViewed: prefs.viewed,
        showNotes: prefs.notes
      }

      const timelineEvents = await rootState.provider.getUserTimeline(rootState.currentUser.me.id, criteria)

      Helpers.adjustTimelineCaseTypeDisplayName(rootState, timelineEvents)
      commit('setCurrentTimeline', timelineEvents)
    }
  },

  async updateRecentCaseData(context, data) {
    try {
      const flaggedCases = context.rootState.homepage.flagged_cases
      const caseIdList = data.caseIdList
      let caseDataUpdated = data.cases

      let urlString = ''
      const paramName = encodeURIComponent('ids[]')

      // Loop through ID's - build param string
      for (let x = 0; x < caseIdList.length; x++) {
        let param = `${paramName}=${caseIdList[x]}`
        if (caseIdList.length !== x + 1) {
          param += '&'
        } else {
          // So .json isnt added to last query string param
          param += '&ignore_format_params='
        }
        urlString += param
      }

      // Get addtional case data that recent case (homepage request) doesn't provide.
      await context.rootState.provider.getMapper('case').getCaseListByIds(data.caseIdList, {
        request: (request) => {
          // Append.json - bit hacky but no other way to supply query string
          request.url = request.url + "?" + urlString
          return request
        }
      }).then((response) => {
        caseDataUpdated = response.data.cases
      })

      // Iterate through cases to fetch displayFields (summary fields)
      for (let x = 0; x < caseDataUpdated.length; x++) {
        const caseData = caseDataUpdated[x]
        const param = encodeURI(caseData.case_type.toLowerCase())
        const caseIndexToUpdate = x
        let isFlagged = Helpers.getArrIndexFromPropMatch(flaggedCases, 'id', caseData._id)

        // Set default flagged value
        isFlagged = (isFlagged !== null)

        // Fetch case type display fields
        await context.rootState.provider.find('case_type', param).then((response) => {
          const displayFields = response.displayFields

          // Format displayFields (summary fields)
          for (let y = 0; y < displayFields.length; y++) displayFields[y].fieldFormatted = Helpers.capitalizeRemoveUnderscores(displayFields[y].field)

          caseData.displayFields = displayFields
          caseData.isFlagged = isFlagged

          // MOCK DATA START - REMOVE ONCE IMPLEMENTED IN API
          if (x % 2 === 0) {
            // Even
            caseData.media = null
            caseData.iconColour = 'green'
            caseData.icon = 'build'
          } else {
            // Odd
            caseData.media = '/img/samples/customer-example.jpg'
            caseData.iconColour = 'red'
            caseData.icon = 'bug_report'
          }
          // MOCK DATA END - REMOVE ONCE IMPLEMENTED IN API
          context.commit('updateRecentCase', { data: caseData, index: caseIndexToUpdate })
          context.commit('updateRecentCaseFlag', { isFlagged: isFlagged, index: caseIndexToUpdate })
        })
      }
      context.commit('setRecentCasesLoading', false)
    } catch (err) {
      console.error("ERROR " + err)
    }
  },
  async formatLastCasesViewed(context) {
    // Loop through and dispatch
    const cases = context.rootState.homepage.recent_cases
    const caseIdList = []

    for (let x = 0; x < cases.length; x++) {
      // const caseType = cases[x].case_type.replace(/ /g, "_").toLowerCase()
      caseIdList.push(cases[x].id)
    }
    context.dispatch("updateRecentCaseData", { caseIdList, cases })
  }

}
